import {UIService} from "../UIService";
import {ProductDataService} from "../../services/productDataService";
import {ProductDataStore} from "../../stores/productDataStore";
import {PlisseSheatingService} from "./plisseSheatingService";
import {ColorService} from "../colorComponent/colorService";

export class PlisseSheatingUIService {
    private uiService: UIService;
    private productDataService: ProductDataService;
    private productDataStore: ProductDataStore;
    private plisseSheatingService: PlisseSheatingService;
    private colorService: ColorService;

    constructor() {
        this.uiService = new UIService();
        this.productDataService = new ProductDataService();
        this.productDataStore = new ProductDataStore();
        this.plisseSheatingService = new PlisseSheatingService();
        this.colorService = new ColorService();
    }

    public initializePlisseSheatingSelector() {
        let plisseSheatings = this.productDataStore.getAvailableOptionsByName('plisseSheatings');

        plisseSheatings.forEach(sheating => {
            const option = this.createPlisseSheatingOption(sheating);
            if (sheating.id === this.productDataStore.getSelectedOptionIdByName('plisseSheating')) {
                this.uiService.setSelectedOption(option);
            }

            option.addEventListener('click', (event: any) => {
                this.productDataService.updateSelectedOptionByName('plisseSheating', sheating.id, true);
                this.uiService.resetSelectionsByPartName('plisseSheating');
                this.uiService.setSelectedOption(event.currentTarget);
                this.setColorPalettes();
            });
        });

        this.setColorPalettes();

        const resetButton = this.uiService.getResetButtonByModule('plisseSheating');
        resetButton.addEventListener('click', this.resetSelectedOptions.bind(this));
    }

    private resetSelectedOptions() {
        this.plisseSheatingService.resetSelectedOptions();
        this.setColorPalettes();
    }

    private createPlisseSheatingOption(sheating) {
        const option = this.uiService.createConfiguratorOption('plisseSheating');

        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            sheating.id
        );

        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute('nf-value-key', 'img', option),
            'src',
            sheating.attributes.imgSrc
        );

        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'name', option),
            sheating.attributes.name
        );

        const price = '+' + sheating.attributes.priceAfterDiscount + `kr`;
        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'price', option),
            price
        );

        return option;
    }

    private setColorPalettes() {
        const selectedPaletteId = this.productDataStore.getSelectedOptionIdByName('plisseSheatingColorPalette');
        const selectedOptionId = this.productDataStore.getSelectedOptionIdByName('plisseSheating');
        const selectedOption = this.productDataStore.getAvailableOptionByNameAndId('plisseSheatings', selectedOptionId);

        let colorPalettes = this.productDataStore.getAvailableOptionsByName('colorPalettes');
        colorPalettes = colorPalettes.filter(palette => selectedOption.attributes.colorPalettes.indexOf(palette.id) > -1);

        this.uiService.removeElementsByPartName('plisseSheatingColorPalette');
        if (colorPalettes.length > 1) {
            colorPalettes.forEach(palette => {
                const option = this.createPaletteOption(palette);

                if (palette.id === selectedPaletteId) {
                    this.uiService.setSelectedOption(option);
                }

                option.addEventListener('click', (event: any) => {
                    this.setColorsInPalette(palette.id);
                    this.productDataService.updateSelectedOptionByName('plisseSheatingColorPalette', palette.id);
                    this.uiService.resetSelectionsByPartName('plisseSheatingColorPalette');
                    this.uiService.setSelectedOption(event.currentTarget);
                });
            });
        }

        this.setColorsInPalette(selectedPaletteId);

        this.uiService.getElementByAttribute('nf-template-action', 'plisseSheatingColorSearchBar').addEventListener('keyup', (event: any) => {
            const selectedPaletteId = this.productDataStore.getSelectedOptionIdByName('plisseSheatingColorPalette');
            this.setColorsInPalette(selectedPaletteId, event.currentTarget.value);
        });
    }

    private setColorsInPalette(paletteId, searchKeyword: string = null) {
        const selectedColorId = this.productDataStore.getSelectedOptionIdByName('plisseSheatingColor');
        let colorsInPalette = this.productDataStore.getAvailableOptionsByName('colors');
        colorsInPalette = colorsInPalette.filter(color => this.colorService.filterColorInPalette(color, paletteId, searchKeyword));

        this.uiService.removeElementsByPartName('plisseSheatingColors');
        colorsInPalette.forEach(color => {
            const option = this.createColorOption(color);

            if (color.id === selectedColorId) {
                this.uiService.setSelectedOption(option);
            }

            option.addEventListener('click', (event: any) => {
                this.productDataService.updateSelectedOptionByName('plisseSheatingColor', color.id, true);
                this.uiService.resetSelectionsByPartName('plisseSheatingColors');
                this.uiService.setSelectedOption(event.currentTarget);
            });
        });
    }

    private createPaletteOption(palette: any) {
        const option = this.uiService.createConfiguratorOption('plisseSheatingColorPalette');

        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            palette.id
        );

        this.uiService.addTextInElement(
            option,
            palette.name
        );

        return option;
    }

    private createColorOption(color: any) {
        const option = this.uiService.createConfiguratorOption('plisseSheatingColor');

        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            color.id
        );

        this.uiService.addTextInElement(
            option,
            (color.attributes.isRal) ? color.attributes.ral : color.attributes.name
        );

        const imgElement = this.uiService.getElementByAttribute('nf-value-key', 'img', option);
        const hexElement = this.uiService.getElementByAttribute('nf-value-key', 'hex', option);

        if (color.attributes.imgThumbSrc) {
            this.uiService.setAttributeToElement(
                imgElement,
                'src',
                color.attributes.imgThumbSrc
            );

            this.uiService.hideElement(hexElement);
        } else {
            this.uiService.setBackgroundColorToElement(
                hexElement,
                color.attributes.hex
            );

            this.uiService.hideElement(imgElement);
        }

        return option;
    }
}
